const Wait = () => {
  return <h1 style={{ textAlign: 'center' }}>Wait For Admin Approvment</h1>
}

export default Wait
